import { IContext } from "@src/context";
import { defineMessages } from "@formatjs/intl";

import "./index.css";

// Fix ts error: Property 'NURVE' does not exist on type 'Window & typeof globalThis'.
declare const window: Window & {
  NURVE: {
    (options: { organization_id: number }): {
      showPanorama: (data: {
        fetchExternalId: () => string;
        putIframe: (iframe: HTMLIFrameElement) => void;
      }) => void;
    };
  };
};

const VILLAGE_HOUSE_VR_ID = 1229;

const messages = defineMessages({
  note: {
    id: "VR.Note",
    defaultMessage:
      "*This is an image of an apartment with the same floor plan, at the same property.",
    description: "The note for the VR popup.",
  },
});

export function setupVR(context: IContext) {
  const container = document.querySelector(
    '.element-popup[data-popup-id="room-vr"]'
  );

  if (container == null) {
    return;
  }

  document.addEventListener("click", (event) => {
    const target = event.target as HTMLElement;
    const button = target.closest(
      '[data-popup-event="popup-open"][data-popup-id="room-vr"]'
    );
    if (button) {
      const roomId = button.getAttribute("data-external-id");
      const NURVE = window.NURVE;

      if (!roomId || !NURVE) return;

      NURVE({ organization_id: VILLAGE_HOUSE_VR_ID }).showPanorama({
        fetchExternalId: function () {
          return roomId;
        },
        putIframe: function (iframe: HTMLIFrameElement) {
          iframe.setAttribute("width", "100%");
          iframe.setAttribute("height", "100%");

          const note = document.createElement("p");
          note.classList.add("container-vr-content-note", "text-center");
          note.innerHTML = context?.intl.formatMessage(messages.note);

          const content = container.querySelector(".container-vr-content");
          content?.replaceChildren(iframe, note);
        },
      });
    }
  });
}
